import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  display: "inline-block",
  cursor: "pointer",
  marginRight: 19,
  "&:last-child": {
    marginRight: 50,
  },
  [theme.breakpoints.up("tablet")]: {
    marginRight: 55,
    "&:last-child": {
      marginRight: 0,
    },
  },
}));

const PersonBgBase = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: 95.3,
  height: 95.3,
  margin: "15px 0",
  borderRadius: "100%",
  [theme.breakpoints.up("mobile")]: {
    width: 146,
    height: 146,
  },
}));

export const PersonBackground = styled(PersonBgBase, {
  shouldForwardProp: (prop) => prop !== "dateTypeTrimmed",
})(({ theme, dateTypeTrimmed }) => ({
  backgroundColor: dateTypeTrimmed ? theme.palette.calendarItemBackground[`${dateTypeTrimmed}`] : undefined,
}));

export const PersonHead = styled("img")(({ theme }) => ({
  width: 39.49,
  objectFit: "contain",
  [theme.breakpoints.up("mobile")]: {
    width: 63,
  },
}));

export const PersonInfo = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const PersonDateType = styled(Typography)(({ theme }) => ({
  marginTop: 8,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 15,
    fontSize: theme.typography.large.fontSize,
  },
}));

export const PersonDate = styled(Typography)(({ theme }) => ({
  marginTop: 5,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 8,
    fontSize: theme.typography.regular.fontSize,
  },
}));

export const Cta = styled(PersonBgBase)({});
